import { Route } from '../AdminTalentSup/routes';
import PublicNewOffer from './pages/offers/new';
import PublicRelocationShow from './pages/relocations/Show';
import StudentRelocationShow from './pages/relocations/Show';

const routes: Route[] = [
  {
    path: '/public/:token/offers/new',
    name: 'newOffer',
    features: ['offers'],
    hideInMenu: true,
    component: PublicNewOffer,
  },
  {
    path: '/public/relocations/:token',
    name: 'relocation',
    features: ['relocation'],
    hideInMenu: true,
    component: PublicRelocationShow,
  },
];

export default routes;
